import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Container,
    Grid,
    CircularProgress,
} from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import SeoMeta from "./SeoMeta";
import { BASE_URL } from "../config/network/ApiUrl";
const LatestIssue = () => {
    const { year, month, issue } = useParams();
    const [stories, setStories] = useState([{}]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [hover, setHover] = useState(false);
    const [hoverImg, setHoverImg] = useState(false);
    const navigate = useNavigate();
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
    const isMobile = useMediaQuery('(max-width: 768px)');
    // console.log("issue data",issue,"issue number",issue.split("-")[1])

    useEffect(() => {
        const fetchStories = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${BASE_URL}api/inside-pages`);
                // const res = await axios.get(`/api/inside-pages`);
                const data = res?.data?.data?.items || [];
                console.log("latest issue data>>", data)

                // Show banner (field_intro_inside_page == null) first
                // const firstStory = data?.find( 
                //     (item) => item?.field_intro_inside_page === null
                // );
                // const remainingStories = data?.filter(
                //     (item) => item?.field_intro_inside_page !== null
                // );
                // const ordered = firstStory ? [firstStory, ...remainingStories] : remainingStories;
                // setStories(ordered);
                setStories(data);
            } catch (err) {
                setError("Failed to load stories");
            } finally {
                setLoading(false);
            }
        };
        fetchStories();
    }, [year, month, issue]);

    const handleNavigate = (story) => {
        console.log("story data", story)
        const slug = story?.title?.toLowerCase().replace(/\s+/g, "-");
        const url = `/${story?.issue_info?.full_issue}/${slug}`;
        navigate(url, { state: { story: story, data: stories } });
        // window.location.reload();

    };

    if (loading)
        return (
            <Box display="flex" justifyContent="center" py={6}>
                <CircularProgress sx={{
                    color: "#dc042b",
                }} />
            </Box>
        );

    if (error)
        return (
            <Typography color="error" align="center" py={4}>
                {error}
            </Typography>
        );

    // --- Color scheme array (based on screenshots)
    const textColors = [
        { bg: "#e31837", topic: "#fff", title: "#fff", intro: "#fff" }, // red bg
        { topic: "#ef762b", title: "#000", intro: "#ef762b" }, // orange
        { topic: "#5377a9", title: "#000", intro: "#5377a9" }, // grey
        { topic: "#8c9651", title: "#000", intro: "#8c9651" }, // green
        { topic: "#b4815b", title: "#000", intro: "#b4815b" }, // brown
        { topic: "#ef762b", title: "#000", intro: "#ef762b" }, // orange again
    ];

    return (
        < >
            <SeoMeta data={stories[0]} />
            {stories?.map((story, index) => {
                const colorSet = textColors[index % textColors.length];
                // const isFirstBannerImage = story?.field_intro_inside_page === null;
                const isFirstBannerImage = index === 0;  ///story?.field_page_order === "0"
                const isEven = (index + 1) % 2 === 0;

                if (isFirstBannerImage) {
                    return (
                        <>
                            <Box
                                className="heroCardWrapper"
                                onMouseEnter={() => !isMobile && setHover(true)}
                                onMouseLeave={() => !isMobile && setHover(false)}
                                sx={{ mb: { md: 6, xs: 3 }, cursor: "pointer" }}
                            >
                                <Box className="imageContainer" onClick={() => handleNavigate(story)}>
                                    <img
                                        src={story.field_banner_image}
                                        alt="Banner"
                                        className={`heroImg ${hover && !isMobile ? "zoomImg" : ""}`}
                                    />

                                    {/* RED BOX - ONLY CONTAINS TEXT CONTENT */}
                                    <Box className={`redBox ${hover && !isMobile ? "expanded" : ""} ${isMobile ? "mobileRedBox" : ""}`}>
                                        <Typography
                                            variant="h4"
                                            className="redBoxTitle"
                                            sx={{ fontFamily: "'DancingScript-Regular'", marginBottom: "10px", fontWeight: "bold", fontSize: "1.6rem", lineHeight: "1.6rem" }}
                                        >
                                            {story.field_topic}
                                        </Typography>

                                        <Typography
                                            variant="h5"
                                            className="redBoxSubtitle"
                                            sx={{ fontFamily: "'Georama-Regular'", marginBottom: "10px", fontSize: "1.875rem", lineHeight: "2.2rem" }}
                                        >
                                            {story.title}
                                        </Typography>

                                        <Button
                                            className={`readMoreBtn ${hover || isMobile ? "showBtn" : ""}`}
                                        //endIcon={<ArrowCircleRightIcon />}
                                        >
                                            Read More <Box
                                                sx={{
                                                    width: 20,
                                                    height: 20,
                                                    ml: 1,
                                                    borderRadius: "50%",
                                                    border: "1px solid #fff",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                →
                                            </Box>
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>

                            {/* <Box
  className="heroCardWrapper"
  onMouseEnter={() => setHover(true)}
  onMouseLeave={() => setHover(false)}
  sx={{mb:{md:6, xs:3}}}
>
  <Box className="imageContainer" onClick={() => handleNavigate(story)}>
    <img
      src={story.field_banner_image}
      alt="Banner"
      className={`heroImg ${hover ? "zoomImg" : ""}`}
    />
    
    <Box className={`redBox ${hover ? "expanded" : ""}`}>
      <Typography 
        variant="h2" 
        className="heroTitle"
        sx={{ fontFamily: "'DancingScript-Regular'", fontSize: "25.6px" }}
      >
        {story.field_topic}
      </Typography>

      <Typography
        variant="h3"
        className="heroSubtitle"
        sx={{ fontFamily: "'Georama-Regular'", fontSize: "1.6rem" }}
      >
        {story.title}
      </Typography>

      <Button
        className={`readMoreBtn ${hover ? "showBtn" : ""}`}
        endIcon={<ArrowForwardIcon />}
      >
        Read More
      </Button>
    </Box>
  </Box>
</Box> */}


                        </>
                    );
                }

                return (
                    <>

                        <motion.div
                            key={story.id}
                            initial={isEven ? { x: 100, opacity: 0 } : { x: -100, opacity: 0 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6, ease: "easeOut" }}
                            viewport={{ amount: 0.3, once: false }} // reset animation on scroll
                        >


                            <Grid container
                                className="mobilePadding"
                                sx={{ pl: 0, pr: 0, cursor: "pointer", mb: { xs: 6, sm: 3, md: 6 } }}
                                spacing={{ xs: 2, md: 6 }} onClick={() => handleNavigate(story)}>

                                {/* ---------------- IMAGE ---------------- */}
                                <Grid
                                    size={{ xs: 12, md: 7 }}
                                    sx={{
                                        order: { xs: 1, md: isEven ? 1 : 2 },
                                    }}
                                >

                                    <Box
                                        component="img"
                                        src={story.field_banner_image}
                                        alt={story.title}
                                        className="shdaowEf"
                                        sx={{
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "cover",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                                        }}
                                    />
                                </Grid>

                                {/* ---------------- CONTENT ---------------- */}
                                <Grid
                                    size={{ xs: 12, md: 5 }}
                                    sx={{
                                        order: { xs: 2, md: isEven ? 2 : 1 },
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    {/* ⭐ Content Hover Area Only */}
                                    <motion.div
                                        whileHover="hover"
                                        initial="rest"
                                        animate="rest"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            width: "100%",
                                        }}
                                    >
                                        <motion.div
                                            variants={{
                                                rest: { y: 0 },
                                                hover: { y: -20 },
                                            }}
                                            transition={{ duration: 0.2 }}
                                        >
                                            {/* TOPIC LABEL */}
                                            {story.field_topic && (
                                                <Box
                                                    className={`topicLabel ${isEven ? "topicLeft" : "topicRight"}`}
                                                    sx={{ backgroundColor: colorSet.topic }}
                                                    style={{ "--topicColor": colorSet.topic }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontFamily: "'DancingScript-Regular', cursive",
                                                            fontSize: "24px",
                                                            fontWeight: 700,
                                                        }}
                                                    >
                                                        {story.field_topic}
                                                    </Typography>
                                                </Box>
                                            )}

                                            {/* TITLE */}
                                            <Typography
                                                sx={{
                                                    color: colorSet.title,
                                                    textAlign: "left",
                                                    fontFamily: "'Georama-Regular'",
                                                    fontSize: { xs: "1.6rem", md: "1.875rem" },
                                                    fontWeight: 400,
                                                    lineHeight: "1.6rem",
                                                }}
                                            >
                                                {story.title}
                                            </Typography>

                                            {/* INTRO */}
                                            <Typography
                                                sx={{
                                                    color: colorSet.intro,
                                                    fontSize: "15px",
                                                    lineHeight: 1.6,
                                                    mb: 3,
                                                    textAlign: "left",
                                                    fontFamily: "'Open Sans', sans-serif",
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: story.field_intro_inside_page,
                                                }}
                                            />
                                        </motion.div>

                                        {/* ⭐ READ MORE BUTTON — appears only on content hover */}
                                        <motion.div >
                                            <motion.div
                                                variants={
                                                    isMdUp
                                                        ? {
                                                            rest: { opacity: 0, y: 0 },
                                                            hover: { opacity: 1, y: 0 },
                                                        }
                                                        : {
                                                            rest: { opacity: 1, y: 0 },
                                                            hover: { opacity: 1, y: 0 },
                                                        }
                                                }
                                                transition={{ duration: 0.35, ease: "easeOut" }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: colorSet.topic,
                                                        color: "#fff",
                                                        textTransform: "none",
                                                        borderRadius: "2px",
                                                        px: 2.5,
                                                        py: 0.8,
                                                        fontSize: "14px",
                                                        "&:hover": {
                                                            backgroundColor: colorSet.topic,
                                                            opacity: 0.9,
                                                        },
                                                    }}
                                                >
                                                    Read more
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            width: 20,
                                                            height: 20,
                                                            backgroundColor: colorSet.topic,
                                                            borderRadius: "50%",
                                                            ml: 1,
                                                            border: "1px solid #fff",
                                                        }}
                                                    >
                                                        <Typography
                                                            component="span"
                                                            sx={{
                                                                fontSize: "14px",
                                                                color: "#fff",
                                                            }}
                                                        >
                                                            →
                                                        </Typography>
                                                    </Box>
                                                </Button>
                                            </motion.div>
                                        </motion.div>
                                    </motion.div>
                                </Grid>

                            </Grid>
                        </motion.div>
                    </>
                );
            })}
        </>

    );
};

export default LatestIssue;







//  {stories?.map((story, index) => {
//                 const colorSet = textColors[index % textColors.length];
//                 const isFirstBannerImage = story?.field_intro_inside_page === null;
//                 const isEven = (index + 1) % 2 === 0;
//                 if (isFirstBannerImage) {
//                     return (
//                         <Box
//                             onClick={() => handleNavigate(story)}
//                             key={story.id}
//                             sx={{
//                                 position: "relative",
//                                 width: "100%",
//                                 backgroundColor: "#fff",
//                                 mb: 8,
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 cursor: "pointer",
//                             }}
//                         >
//                             {/* Banner Image */}
//                             <Box
//                                 component="img"
//                                 src={story.field_banner_image}
//                                 alt="Banner"
//                                 sx={{
//                                     width: "90%",
//                                     boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//                                     cursor: "pointer",
//                                     borderRadius: "4px",
//                                 }}

//                             />

//                             {/* Red Overlay Box */}
//                             <Box
//                                 sx={{
//                                     position: "absolute",
//                                     bottom: "-4.5%",
//                                     right: "9%",
//                                     backgroundColor: "#e31837",
//                                     color: "#fff",
//                                     padding: "24px 36px",
//                                     borderRadius: "2px",
//                                     boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
//                                     width: "60%",
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "center",
//                                     alignItems: "center",
//                                     textAlign: "center",
//                                     height: "25%"
//                                 }}
//                             >
//                                 {/* field_topic - top right */}
//                                 <Typography
//                                     sx={{
//                                         fontFamily: "'DancingScript-Regular', cursive",
//                                         fontSize: "24px",
//                                         fontWeight: 700,
//                                         lineHeight: 1.2,
//                                         color: "#fff",
//                                         position: "absolute",
//                                         top: "16px",
//                                         right: "28px",
//                                     }}
//                                 >
//                                     {story.field_topic}
//                                 </Typography>

//                                 {/* title - center text */}
//                                 <Typography
//                                     sx={{
//                                         fontFamily: "'Georama-Regular'",
//                                         fontSize: "1.6rem",
//                                         fontWeight: 400,
//                                         lineHeight: "1.6rem",
//                                         color: "#fff",
//                                         maxWidth: "100%",
//                                         whiteSpace: 'nowrap',

//                                     }}
//                                 >
//                                     {story.title}
//                                 </Typography>

//                                 {/* Read More Button - bottom right */}
//                                 <Box
//                                     sx={{
//                                         position: "absolute",
//                                         bottom: "16px",
//                                         right: "28px",
//                                         display: "inline-flex",
//                                         alignItems: "center",
//                                         backgroundColor: "#000",
//                                         color: "#fff",
//                                         px: 2.5,
//                                         py: 0.8,
//                                         borderRadius: "2px",
//                                         fontSize: "14px",
//                                         fontWeight: 500,
//                                         cursor: "pointer",
//                                         "&:hover": {
//                                             backgroundColor: "#222",
//                                         },
//                                     }}
//                                 >
//                                     Read more
//                                     <Box
//                                         sx={{
//                                             display: "flex",
//                                             justifyContent: "center",
//                                             alignItems: "center",
//                                             width: 20,
//                                             height: 20,
//                                             backgroundColor: "#000",
//                                             borderRadius: "50%",
//                                             ml: 1,
//                                             border: "1px solid #fff",
//                                         }}
//                                     >
//                                         <Typography
//                                             component="span"
//                                             sx={{
//                                                 fontSize: "14px",
//                                                 lineHeight: 1,
//                                                 color: "#fff",
//                                             }}
//                                         >
//                                             →
//                                         </Typography>
//                                     </Box>
//                                 </Box>
//                             </Box>
//                         </Box>
//                     );
//                 }

//                 // Subsequent Rows (side-by-side layout)
//                 return (
//                     <Container
//                         key={story.id}
//                         sx={{
//                             mb: 10,
//                             cursor: "pointer",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "space-between",
//                             flexDirection: isEven ? "row" : "row-reverse",
//                             gap: 6,
//                         }}
//                         onClick={() => handleNavigate(story)}
//                     >
//                         {/* IMAGE */}
//                         <motion.div whileHover={{ scale: 1.03 }}>
//                             <Box
//                                 component="img"
//                                 src={story.field_banner_image}
//                                 alt={story.title}
//                                 sx={{
//                                     width: "95%",
//                                     height: "auto",
//                                     borderRadius: "8px",
//                                     boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
//                                     objectFit: "cover",
//                                 }}
//                             />
//                         </motion.div>

//                         {/* TEXT */}
//                         <Box
//                             sx={{
//                                 width: "50%",
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 justifyContent: "center",
//                             }}
//                         >
//                             {/* Topic Tag */}
//                             {story.field_topic && <Box
//                                 sx={{
//                                     display: "inline-block",
//                                     backgroundColor: colorSet.topic,
//                                     //   color: colorSet.topic,
//                                     color: "#fff",
//                                     px: 2,
//                                     py: 0.5,
//                                     borderRadius: "4px",
//                                     mb: 2,
//                                     alignSelf: "flex-start",
//                                 }}
//                             >
//                                 <Typography
//                                     sx={{
//                                         fontFamily: "'DancingScript-Regular', cursive",
//                                         fontSize: "24px",
//                                         fontWeight: 700,
//                                     }}
//                                 >
//                                     {story.field_topic}
//                                 </Typography>
//                             </Box>}

//                             {/* Title */}
//                             {story.title && <Typography
//                                 // variant="h5"
//                                 sx={{
//                                     // fontWeight: 520,
//                                     // fontSize: "24px",
//                                     // mb: 1.5,
//                                     //   color: "#000",
//                                     color: colorSet.title,
//                                     textAlign: "left",
//                                     fontFamily: "'Georama-Regular'",
//                                     fontSize: "1.6rem",
//                                     fontWeight: 400,
//                                     lineHeight: "1.6rem",

//                                 }}
//                             >
//                                 {story.title}
//                             </Typography>}

//                             {/* Intro */}
//                             <Typography
//                                 sx={{
//                                     color: colorSet.intro,
//                                     fontSize: "15px",
//                                     lineHeight: 1.6,
//                                     mb: 3,
//                                     fontFamily: "'Open Sans', sans-serif",
//                                     textAlign: "left",
//                                 }}
//                                 dangerouslySetInnerHTML={{
//                                     __html: story.field_intro_inside_page,
//                                 }}
//                             />

//                             {/* Button */}
//                             <Button
//                                 variant="contained"
//                                 sx={{
//                                     backgroundColor: colorSet.topic,
//                                     color: "#fff",
//                                     textTransform: "none",
//                                     borderRadius: "2px",
//                                     px: 2.5,
//                                     py: 0.8,
//                                     fontSize: "14px",
//                                     alignSelf: "flex-start",
//                                     "&:hover": {
//                                         backgroundColor: colorSet.topic,
//                                         opacity: 0.9,
//                                     },
//                                 }}
//                             >
//                                 Read more
//                                 <Box
//                                     sx={{
//                                         display: "flex",
//                                         justifyContent: "center",
//                                         alignItems: "center",
//                                         width: 20,
//                                         height: 20,
//                                         backgroundColor: colorSet.topic,
//                                         borderRadius: "50%",
//                                         ml: 1,
//                                         border: "1px solid #fff",
//                                     }}
//                                 >
//                                     <Typography
//                                         component="span"
//                                         sx={{
//                                             fontSize: "14px",
//                                             lineHeight: 1,
//                                             color: "#fff",
//                                         }}
//                                     >
//                                         →
//                                     </Typography>
//                                 </Box>
//                             </Button>
//                         </Box>
//                     </Container>
//                 );

//             })}




